// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"322cd713","65":"ceb88214","533":"acf62bc7","585":"e76b60e9","602":"cd23e96b"}[chunkId] + ".chunk.css";
};